import { render, staticRenderFns } from "./BasicEmbed.vue?vue&type=template&id=cb0ed60e"
import script from "./BasicEmbed.vue?vue&type=script&lang=js"
export * from "./BasicEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports